
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  feedback: true,
  toc: true,
  layout: 'guide',
  description: 'Use Variable Recurring Payments to power automated bill payments'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Variable Recurring Payments' subtitle='Use Variable Recurring Payments to power automated bill payments' mdxType="Header" />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Variable Recurring Payments (VRP) allows you to obtain bank account details and end-user consent for payments within a set of limits. You can then use VRP to automatically initiate payments from your customer's bank account, without requiring additional end user interaction for each transfer. `}</p>
    <p>{`VRP is ideal for creating automated recurring bank payments, especially when the payment amount can change from payment to payment, such as for usage-based subscription services, utility payments, or credit card payments.`}</p>
    <p>{`By combining one-time payments with the optional `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/"
      }}>{`Virtual Accounts`}</a>{` product, you can enable additional functionality, such as sending refunds to users, allowing your users to pay out a credit balance to a bank account, or gaining granular visibility into the settlement status of a payment.`}</p>
    <Callout mdxType="Callout">
      <p>{` To use Variable Recurring Payments, your end users must bank in the UK (your company can be based elsewhere). To request access, contact your account manager. If you are not yet a Plaid customer, `}<a parentName="p" {...{
          "href": "https://plaid.com/contact/"
        }}>{`contact sales`}</a>{`.`}</p>
    </Callout>
    <p>{`For more information on Variable Recurring Payments, see the `}<a parentName="p" {...{
        "href": "https://support.plaid.com/hc/en-us/articles/24622039958295-What-are-Variable-Recurring-Payments-VRPs"
      }}>{`VRP FAQ`}</a>{`.`}</p>
    <Image src='/assets/img/docs/payment_initiation/vrp.png' alt="Plaid Link VRP setup showing bank selection, authentication, and success confirmation for recurring payments." expandable={true} mdxType="Image" />
    <h4 {...{
      "id": "implementation-process"
    }}>{`Implementation process`}</h4>
    <p>{`See the `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/variable-recurring-payments/add-to-app"
      }}>{`Add Variable Recurring Payments to your App`}</a>{` guide to learn more about the product and how to implement it using Plaid Link.`}</p>
    <h4 {...{
      "id": "testing-variable-recurring-payments"
    }}>{`Testing Variable Recurring Payments`}</h4>
    <p>{`Variable Recurring Payments can immediately be tried out with test data in the Sandbox environment. In order to test payments against live Items in Production, you will need to first request access by `}<a parentName="p" {...{
        "href": "https://plaid.com/contact"
      }}>{`contacting sales`}</a>{` or your account manager.`}</p>
    <p>{`For details on any payment limits in Production, contact your Plaid account manager.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "implementation-process",
        level: 4,
        title: "Implementation process",
      },
{
        id: "testing-variable-recurring-payments",
        level: 4,
        title: "Testing Variable Recurring Payments",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
